import { computed } from 'mobx';

export default class ReportingTemplateModel {
  id;
  store;

  constructor(store, item) {
    this.store = store;
    this.updateFromJson(item);
  }

  @computed get asJson() {
    return {
      id: this.id,
      name: this.name,
      description: this.description,
      format: this.format,
      orientation: this.orientation,
      max_missing_values: this.max_missing_values,
      columns: this.columns,
      header_id: this.header_id,
      sort_order:this.sort_order,
      sort_by:this.sort_by
    };
  }

  updateFromJson(json) {
    this.id = json.id;
    this.name = json.name;
    this.description = json.description;
    this.format = json.format;
    this.orientation = json.orientation;
    this.max_missing_values = json.max_missing_values;
    this.columns = json.columns;
    this.header_id = json.header_id;
    this.sort_order = json.sort_order
    this.sort_by = json.sort_by
  }
}



// WEBPACK FOOTER //
// ./src/models/SystemConfiguration/ReportingTemplateModel.js